module.exports = __webpack_public_path__ + "img/image-icon.83f25b83.svg";